module.exports = __webpack_public_path__ + "img/David_SW_21.9f747c3d.jpg";